module.exports = __webpack_public_path__ + "static/media/dressingBride.b2bdf402.png";